import i18next from "i18next";
import React, { useContext, useEffect, useMemo, useState } from "react";

import useStyles from "../../../style/js-style/containers/thirdparties/sheet/ThirdpartyDataHubStyle";

import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import EAIcon from "components/common/EAIcon";
import EATabPanel from "components/common/EATabPanel";
import DataHubPanel from "./data-hub/DataHubPanel";
import { RoleBasedAccessControlContext } from "services/common/RolesUtils";
import { Context } from "states/Store";
import clsx from "clsx";
import { getDataHubSources } from "services/common/DataHubUtils";
import { TPSheetTabs } from "services/common/Constants";

const a11yProps = (tabId) => {
  return {
    id: `${tabId}-tab`,
    "aria-controls": `${tabId}-tabpanel`,
  };
};

function ThirdpartyDataHub({ thirdPartyId, isUnmanaged, setExpanded }) {
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);
  const [value, setValue] = useState();
  const { classes } = useStyles();
  const [state,] = useContext(Context);
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    const dataHubSubscriptions = state.account.subscriptions.filter(s => s.includes("DATA_HUB_"));
    setSubscriptions(dataHubSubscriptions);
  }, [state.account]);

  const dataHubTabs = useMemo(() => {
    return getDataHubSources().filter(s => subscriptions.includes(s.subscription))
  }, [subscriptions]);

  useEffect(() => {
    // We take the first source the user is allow to see.
    let defaultTab = dataHubTabs.filter(s => hasAnyOfPrivileges(s?.neededPrivilege))?.[0];
    setValue(defaultTab?.id);
  }, [dataHubTabs, hasAnyOfPrivileges]);

  const handleChange = (event, newValue) => {
    const newId = event.target.id.substring(0, event.target.id.length - 4);
    setValue(newId);
  };

  const tabClassName = (index) => {
    return value === index ? classes.selectedTab : classes.unselectedTab
  };

  return (
    <>
      <div className={classes.infoPanel}>
        {isUnmanaged ?
          <div className={classes.rootNotActivable}>
            <span className={classes.notActivableText}>{i18next.t(`unmanagedThirdParty.optionNotAvailable`) + " " + i18next.t(`thirdpartySheet.${TPSheetTabs.DATA_HUB}.title`)}</span>
          </div>
          : <>
            <Typography variant="h6" className={classes.blocTitle}>
              <EAIcon icon={"source_black"} className={classes.icon} />
              <span className={classes.title}>{i18next.t("thirdpartySheet.dataHub.availableSources")}</span>
            </Typography>
            <Grid container item>
              {/* Tabs */}
              <Box className={classes.tabsWrapper}>
                <Tabs
                  aria-label="dashboard tabs"
                  value={value}
                  onChange={handleChange}
                  orientation="vertical"
                  variant="scrollable"
                  style={{ borderRight: 1, borderColor: 'divider' }}
                >
                  {dataHubTabs.map((tab, index) => (
                    <Tab
                      key={tab.id}
                      label={tab.label}
                      {...a11yProps(tab.id)}
                      disabled={!hasAnyOfPrivileges(tab.neededPrivilege)}
                      className={clsx(tabClassName(tab.id), classes.tab)}
                    />
                  ))}
                </Tabs>
              </Box>
              {dataHubTabs.map((tab, index) => (
                <EATabPanel
                  key={tab.id}
                  value={value}
                  index={tab.id}
                  style={{ width: 'calc(100% - 200px)' }}
                >
                  <DataHubPanel thirdPartyId={thirdPartyId} dataType={tab.id} setExpanded={setExpanded}/>
                </EATabPanel>
              ))}
            </Grid>
          </>
        }
      </div>

    </>
  );
}

export default ThirdpartyDataHub;
